import React, { useState, useCallback } from 'react';
import Lobby from './Lobby';
import Table from './Table';
import './Backgammon.css';

// Remembers the open table across card close/reopen.
const KEY = 'bg_open_table';

export default function BackgammonPage() {
  const [tableId, setTableId] = useState(() => {
    try { return localStorage.getItem(KEY) || null; } catch (e) { return null; }
  });

  const open = useCallback((id) => {
    setTableId(id ? String(id) : null);
    try {
      if (id) localStorage.setItem(KEY, String(id));
      else localStorage.removeItem(KEY);
    } catch (e) { /* private mode */ }
  }, []);
  const exit = useCallback(() => open(null), [open]);

  return (
    <div className="bg-root">
      {tableId ? <Table key={tableId} tableId={tableId} onExit={exit} onOpenTable={open} /> : <Lobby onOpenTable={open} />}
    </div>
  );
}
